import PropTypes from "prop-types"
import { Typography, Tooltip } from "@mui/material"
import moment from "moment"

export default function LastUpdated({ timestamp, staleThresholdDays = 1, className = "" }) {
  if (!timestamp) {
    return null
  }

  const isStale = moment().diff(moment(timestamp), "days") > staleThresholdDays
  const lastUpdatedClass = isStale ? "last-updated-stale" : "last-updated-fresh"

  return (
    <Tooltip title={moment(timestamp).format("MMMM Do YYYY, h:mm:ss a")}>
      <Typography
        variant="caption"
        className={`${lastUpdatedClass} ${className}`.trim()}
      >
        Last updated {moment(timestamp).fromNow()}
      </Typography>
    </Tooltip>
  )
}

LastUpdated.propTypes = {
  timestamp: PropTypes.instanceOf(Date).isRequired,
  staleThresholdDays: PropTypes.number,
  className: PropTypes.string,
}
